export default __webpack_public_path__ + "static/media/p1ti1-m.a4ec4864.png";